// extracted by mini-css-extract-plugin
export default {"tx":"_8ead063979","line":"bdd6944bd3"};